var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineArrowRight5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16 18.7c-1.23-.71-1.91-2.14-1.91-4.02V9.33c0-1.88.68-3.31 1.91-4.02 1.23-.71 2.8-.58 4.44.36l4.63 2.67c1.63.94 2.53 2.24 2.53 3.66s-.9 2.72-2.53 3.66l-4.63 2.67c-.94.55-1.86.82-2.7.82-.63 0-1.22-.15-1.74-.45zM7.9 6.61C7.16 7.04 6.75 8 6.75 9.33v5.34c0 1.32.41 2.29 1.16 2.72.75.43 1.79.3 2.94-.36l4.63-2.67c1.15-.66 1.78-1.5 1.78-2.36 0-.86-.63-1.7-1.78-2.36l-4.63-2.67c-.71-.41-1.37-.61-1.95-.61-.37 0-.71.08-1 .25z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineArrowRight5);
export default __webpack_public_path__ + "static/media/vuesax-outline-arrow-right_5.4426bdb62e1578de23ad98c56a727ad5.svg";
export { ForwardRef as ReactComponent };